<template>
  <el-dialog
    class="modal"
    title="提示"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="348px"
    width="452px"
    height="250px"
    border
    center
  >
    <div class="desc">
      <div>你开通的《{{this.course.packageName}}》有效期仅剩 <span style="color: red">{{this.course.day}} </span>天
      </div>
      如需延期，请联系运营人员处理
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="medium" type="primary" @click="toCourse" style="width: 148px;">去查看</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      visible: false,
      course: {}
    }
  },
  mounted() {
    this.fetchPackages() // 获取课程信息
  },
  watch: {
    user() {
      // 拿到vuex中的user时触发
      this.interceptShow()
    },
    '$route.path'() {
      this.interceptShow()
    },
    // 监听day变化
    day() {
      this.interceptShow()
    },
    isTeacher() {
      this.interceptShow()
    }
  },
  computed: {
    ...mapState(['user']),
    isTeacher() {
      return this.user && (this.user.role_id === 10001 || this.user.role_id === 10002)
    },
    day() {
      return this.course.day
    }
  },
  methods: {
    // 拿到即将过期的课包信息
    async fetchPackages() {
      try {
        const { data } = await API.get('/edu/zone/lesson/offical/packages/expired')
        this.course = data[0]
      } catch {
      }
    },
    toCourse() {
      this.visible = false
      sessionStorage.setItem('courseType', 'offical')
      this.$router.push(
        `/courseManage/list/${this.course.packageId}?topicId=${this.course.topicId}&pacakgeEntryType=0`
      )
    },
    interceptShow() {
      if (this.$route.path === '/dashboard' && this.visible === false && this.user.id && this.isTeacher) {
        this.show()
      }
    },
    // 控制过期提醒弹窗的弹出
    firstVisible(str) {
      // 通过localStorage判断是否是第一次弹窗
      let showeds = JSON.parse(localStorage.getItem(`modalFlag${str}`) || '[]')
      const showed = showeds.includes(`${this.user.id}_${this.course.packageId}`)
      if (!showed) {
        this.visible = true
        showeds = []
        showeds.push(`${this.user.id}_${this.course.packageId}`)
        localStorage.setItem(`modalFlag${str}`, JSON.stringify(showeds))
      }
    },
    show() {
      // 弹窗出现的3个时段
      if (this.day >= 16 && this.day <= 30) this.firstVisible(1)
      if (this.day >= 4 && this.day <= 15) this.firstVisible(2)
      if (this.day >= 1 && this.day <= 3) this.firstVisible(3)
    }
  }
}
</script>

<style lang="scss" scoped>

/deep/ .el-dialog {
  border-radius: 4px;
  height: 244px;
}
.desc {
  width: 372px;
  height: 42px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
  text-align: center;
}
/deep/ .el-dialog__title {
  width: 32px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #333333;
  margin-bottom: 5px;
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #EDEDED;
}
/deep/ .el-dialog__footer {
  margin-top: 21px;
  margin-bottom: 10px;
}
</style>
